import { request } from 'lib/api'
import { HTTP_METHODS } from './const'

class VirtualTryOn {
  static generateVirtualTryOnImage(options) {
    return request({
      url: 'v7/virtual-try-on',
      method: HTTP_METHODS.post,
      body: options.body,
    })
  }

  static getVirtualTryOnImage(try_on_id, model_photo) {
    return request({
      url: 'v7/virtual-try-on',
      method: HTTP_METHODS.get,
      params: { try_on_id, model_photo },
    })
  }

  static virtualTryOnImageGenerator(options) {
    return request({
      url: 'v7/virtual-try-on/image-generator',
      method: HTTP_METHODS.post,
      body: options.body,
      timeout: 30000,
    })
  }
}

export default VirtualTryOn
